import { ErrorBoundary } from "react-error-boundary";
import { FiSettings } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import BaseEnergyChart from "@/components/Consumption/BaseEnergyChart";
import ConsumBreakdownChart from "@/components/Consumption/ConsumBreakdownChart";
import ConsumptionHousehold from "@/components/Consumption/ConsumptionHousehold";
import EnergyUsageChart from "@/components/Consumption/EnergyUsageChart";
import EstimatedCostCard from "@/components/Consumption/EstimatedCostCard";
import DateTimeSelector from "@/components/common/DateTimeSelector";
import { UnitToggle } from "@/components/common/UnitToggle";
import Footer from "@/components/footer/footer";
import { useConfig } from "@/context/use-context";

const Consumption = () => {
	const navigate = useNavigate();
	const { pod } = useConfig();

	return (
		<div className="px-2 py-4 mb-20 mt-10">
			{/* Header */}
			<div className="p-2">
				<div className="flex justify-between items-center mb-4">
					<h1 className="text-xl font-bold text-gray-800">Ma consommation</h1>
					<button
						type="button"
						className="text-gray-600 hover:text-gray-800 transition"
						onClick={() => navigate("/setting")}
					>
						<FiSettings className="w-6 h-6" />
					</button>
				</div>
			</div>

			<div className="max-w-md mx-auto px-2 space-y-4">
				<ErrorBoundary
					fallbackRender={({ error }) => <div>{error.message}</div>}
				>
					<EstimatedCostCard />
				</ErrorBoundary>

				<DateTimeSelector />

				<UnitToggle />

				{pod?.pricing_option === "BASE" ? (
					<BaseEnergyChart />
				) : (
					<EnergyUsageChart />
				)}

				{pod?.pricing_option === "HPHC" && <ConsumBreakdownChart />}

				<ConsumptionHousehold />
				<Footer />
			</div>
		</div>
	);
};

export default Consumption;
